import { updateField } from 'vuex-map-fields'

const SET_CODING_QUESTIONS = (state, payload) => {
  state.codingQuestions = payload
}

const SET_CODING_QUESTION = (state, payload) => {
  state.codingQuestion = payload
}

const SET_CONSULTANT_LIST = (state, payload) => {
  state.consultantList = payload
}

const SET_CODING_QUESTION_STATUS_LIST = (state, payload) => {
  state.codingQuestionStatusList = payload
}

const PUSH_CODING_QUESTION_COMMENT = (state, payload) => {
  state.codingQuestion.codingQuestionsComments.push(payload)
}

const PUSH_CODING_QUESTION_ATTACHMENT = (state, payload) => {
  state.codingQuestion.codingQuestionsAttachments.push(payload)
}

const SPLICE_ATTACHMENT = (state, payload) => {
  let index = state.codingQuestion.codingQuestionsAttachments.findIndex(x => x.attachmentId === payload.attachmentId)
  state.codingQuestion.codingQuestionsAttachments.splice(index, 1)
}

export default {
  updateField,
  SET_CODING_QUESTIONS,
  SET_CODING_QUESTION,
  SET_CODING_QUESTION_STATUS_LIST,
  SET_CONSULTANT_LIST,
  PUSH_CODING_QUESTION_COMMENT,
  PUSH_CODING_QUESTION_ATTACHMENT,
  SPLICE_ATTACHMENT
}
